import { View, Button } from "@/components/ui";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { Typography } from "@/components/shared/typography";

export const ModalRemoveCard = ({
  open,
  setOpenRemoveConfirmation,
  onDeleteCard,
  onClose,
}: {
  open: boolean;
  setOpenRemoveConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteCard: () => void;
  onClose: () => void;
}) => {
  return (
    <BottomDrawerModal open={open} onOpenChange={setOpenRemoveConfirmation}>
      <View className="flex flex-col gap-4 px-1">
        <Typography>Remove Credit Card</Typography>
        <Typography variant="body-lg">
          Are you sure you want to remove this credit card? This action cannot
          be undone.
        </Typography>

        <View className="flex flex-col gap-2 pb-2">
          <Button
            variant="primary"
            color="CTA"
            onClick={onDeleteCard}
            children="Remove Credit Card"
          />
          <Button
            variant="secondary"
            color="CTA2"
            onClick={onClose}
            children="Cancel"
          />
        </View>
      </View>
    </BottomDrawerModal>
  );
};
